import React from 'react'
import Countdown from 'react-countdown'

import { Badge } from '@wartek-id/badge'
import { Text } from '@wartek-id/text'

import { formatDate } from 'utils/datetime'

interface AssessmentExpiredDateProps {
  date: string
  showHelperText?: boolean
  textColor?: 'default' | 'subdued'
}

export default function AssessmentExpiredDate({
  date,
  showHelperText,
  textColor = 'subdued',
}: AssessmentExpiredDateProps) {
  // eslint-disable-next-line react-hooks/exhaustive-deps
  const dateAsObject = React.useMemo(() => new Date(date), [])
  const currentDate = React.useMemo(() => new Date(), [])
  const isExpiredToday = formatDate(dateAsObject) === formatDate(currentDate)

  return (
    <Countdown
      date={dateAsObject}
      intervalDelay={60 * 1000} // 1 minutes
      renderer={({ hours, minutes, completed }) => {
        if (completed) {
          // Render an expired state
          return (
            <Text color={textColor} variant="helper">
              {showHelperText && <span>Ditutup (Kedaluwarsa):&nbsp; </span>}
              <span>{formatDate(date, 'EE, dd MMM • HH:mm')} WIB</span>
            </Text>
          )
        } else {
          // Render a countdown

          return (
            <div className="flex items-center">
              {showHelperText && (
                <Text color={textColor} variant="helper">
                  Tautan Kedaluwarsa:&nbsp;
                </Text>
              )}
              <Text color={textColor} variant="helper">
                {!isExpiredToday && (
                  <span>{formatDate(date, 'EE, dd MMM • HH:mm')} WIB</span>
                )}

                {isExpiredToday && hours >= 6 && (
                  <span>
                    Hari Ini, {formatDate(date, 'dd MMM • HH:mm')} WIB
                  </span>
                )}

                {isExpiredToday && hours < 6 && (
                  <Badge variant="warning" className="!text-xs">
                    <span>
                      {hours > 0 && <span>{hours} jam&nbsp;</span>}
                      {minutes > 0 && <span>{minutes} menit&nbsp;</span>}
                      lagi
                    </span>
                  </Badge>
                )}
              </Text>
            </div>
          )
        }
      }}
    />
  )
}
